import { Component } from 'react';
import PropTypes from 'prop-types'

class Img extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: props.src,
      errored: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.src !== state.src && !state.errored) {
      return { src: props.src };
    }
    return null;
  }

  onError = () => {
    if (!this.state.errored) {
      this.setState({
        src: this.props.fallbacksrc,
        errored: true,
      });
    }
  }

  render() {
    const { src, errored } = this.state;
    const { fallbacksrc, className, src: propSrc, ...rest } = this.props;
    return (
      <img
        {...rest}
        src={src}
        alt=""
        onError={this.onError}
        className={`${className} ${errored ? 'errored' : ''}`}
      />
    )
  }
}
Img.propTypes = {
  src: PropTypes.string,
  fallbacksrc: PropTypes.string,
}
Img.defaultProps = {
  className: ''
}

export default Img